module.exports = __webpack_public_path__ + "img/c54627a3dedbc3fe416ee53aa2d2af42.png";